import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Spinner from 'components/atomic/Spinner';
import Text from 'components/atomic/layouts/Text';

import TasksListItem from './TasksListItem';

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledContainer = styled(forwardRef(({ loading, ...props }, ref) => <div ref={ref} {...props} />))`
  /* min-height: 234px; */
  flex-grow: 1;

  padding-top: ${theme.spaces.medium}px;
  padding-right: ${theme.spaces.small}px;

  overflow: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${hexToRGBA(theme.colors.gray.secondary, 0.1)} 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${hexToRGBA(theme.colors.gray.secondary, 0.5)} 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  ${({ loading }) =>
    loading &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      overflow: unset;
      overflow-x: unset;
      padding-top: 0;
      padding-right: 0;
    `}

  @media ${theme.devices.tablet} {
    min-height: unset;
    overflow: unset;
    overflow-x: unset;
    padding-right: unset;

    ${({ loading }) =>
      loading &&
      css`
        padding-top: ${theme.spaces.medium}px;
      `}
  }
`;

const TasksList = ({ loading, items = [], onActionClick }) => {
  if (loading) {
    return (
      <StyledContainer loading>
        <Spinner />
      </StyledContainer>
    );
  }

  if (!items.length) {
    return (
      <StyledContainer loading>
        <Text size={theme.fontSizes.small} weight={400} color={theme.colors.gray.primary} centered>
          No data available
        </Text>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      {items.map((item) => (
        <TasksListItem key={item.id || item.fileRequest?.id} {...item} onActionClick={onActionClick} />
      ))}
    </StyledContainer>
  );
};

TasksList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      productId: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
      subject: PropTypes.string,
      message: PropTypes.string,
      fileRequest: PropTypes.object,
    })
  ),
  onActionClick: PropTypes.func,
};

export default TasksList;
